<template lang="pug">
  .simple.authentication-form
    slot(name="header")
    main.auth-container
      Spinner(v-if="loading" :size="16" :thickness="3")
      Authenticate(
        v-else
        defaultTab="signin"
        :registration="false"
      )
</template>

<script>
import uniqid from 'uniqid';
import { mapActions } from 'vuex';

import store from '@/store';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';

export default {
  name: 'EmailVerificationForm',
  data() {
    return {
      success: false,
      loading: false
    };
  },
  components: {
    Authenticate
  },
  computed: {
    hash() {
      return this.$route.params.hash;
    },
    signature() {
      return this.$route.params.signature;
    },
    expires() {
      return this.$route.params.expires;
    },
    id() {
      return this.$route.params.id;
    }
  },
  methods: {
    verifyEmail() {
      this.loading = true;

      let errorMessage = {
        id: uniqid(),
        title: 'Fehler',
        text: 'Es gibt ein technisches Problem.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
        type: 'error',
        autoclose: false
      };

      try {
        const payload = {
          hash: this.hash, //email hash
          id: this.id,
          signature: this.signature,
          expires: this.expires
        };
        store
          .dispatch('auth/verifyEmail', payload)
          .then(data => {
            if (data.success) {
              this.addMessage({
                id: uniqid(),
                title: 'Erfolg',
                text: 'Ihr Account wurde freigeschaltet.<br>Sie können sich jetzt mit Ihren Zugangsdaten anmelden.',
                type: 'success',
                autoclose: 8000
              });
            } else {
              this.addMessage({
                id: uniqid(),
                title: 'Info',
                text: 'Ihr Account wurde bereits freigeschaltet.<br>Sie können sich mit Ihren Zugangsdaten anmelden.',
                type: 'info',
                autoclose: 8000
              });
            }

            this.success = true;
          })
          .catch(error => {
            console.error(error);
            this.addMessage(errorMessage);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        console.error(error);
        this.addMessage(errorMessage);
        this.loading = false;
      }
    },
    ...mapActions({
      addMessage: 'message/add'
    })
  },
  mounted() {
    this.verifyEmail();
  }
};
</script>

<style lang="sass" scoped>
.authentication-form
  padding-top: 0
h2
  padding-top: 4.5rem
</style>
